import * as React from 'react';
import { GlobalStyles } from '@mui/material';

type Props = React.PropsWithChildren<{}>;

export const OverridenGlobalStyles: React.FC<Props> = ({ children }) => (
    <>
      <GlobalStyles
      styles={{
        '.MuiPopover-root .MuiPaper-root.MuiPopover-paper[class*="MUIDataTableToolbar-filterPaper"]': {
          maxWidth: 529,
          width: 'min(92vw, 529px)',
          margin: '8px',
        },

        '.MuiPopover-root [class*="MUIDataTableFilter-root"] .MuiGrid-container': {
          display: 'flex',
          flexWrap: 'wrap',
          columnGap: '12px',
        },
        '.MuiPopover-root [class*="MUIDataTableFilter-root"] [class*="MuiGrid-container"] > [class*="MuiGrid"]': {
          maxWidth: 'calc(50% - 6px) !important',
          flexBasis: 'calc(50% - 6px) !important',
          width: 'calc(50% - 6px) !important',
        },
        '.MuiPopover-root [class*="MUIDataTableFilter-root"] .MuiFormControl-root': {
          width: '100% !important',
          maxWidth: '100% !important',
        },

        '.MuiPopover-root [class*="MUIDataTableFilter-root"] .MuiInputBase-root': {
          fontSize: '0.9rem',
        },
        '.MuiPopover-root [class*="MUIDataTableFilter-root"] .MuiInputLabel-root, .MuiPopover-root [class*="MUIDataTableFilter-root"] .MuiFormHelperText-root': {
          fontSize: '0.9rem',
        },

        '@media (max-width: 600px)': {
          '.MuiPopover-root [class*="MUIDataTableFilter-root"] [class*="MuiGrid-container"] > [class*="MuiGrid"]': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            width: '100% !important',
          },
          '.MuiPopover-root [class*="MUIDataTableFilter-root"] .MuiFormControl-root': {
            width: '100% !important',
          },
        },
      }}
    />
       {children}
    </>
);
